// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
const getContentModelId = content => content?.sys.contentType.sys.id;
export { getContentModelId };
//# sourceMappingURL=getContentModelId.js.map
